import { getCategoryFilterTree } from 'clients/MarketingClient';
import create from 'zustand';

const useCategoryFilterTree = create((set, get) => ({
  categoryFilterTree: [],  // Store the category list
  isLoading: false,        // Whether it is fetching or not
  isFetched: false,        // Đã gọi API xong (kể cả lỗi / rỗng): phân biệt "chưa tải" với "tải xong mà không có"
  error: null,             // Error if any

  // Fetch the API
  fetchCategoryFilterTree: async () => {
    const state = get();  // Get current state from store

    // CHECK 1: If data already exists → return immediately (no refetch)
    if (state.categoryFilterTree.length > 0) {
      return state.categoryFilterTree;
    }

    // CHECK 2: If still fetching → return immediately (avoid duplicate fetch)
    if (state.isLoading) {
      return state.categoryFilterTree;
    }

    // Start fetching
    set({ isLoading: true, isFetched: false, error: null });
    try {
      const res = await getCategoryFilterTree();  // Call API
      if (res.status === 'OK') {
        // Fetch successfully → save data to store
        set({ categoryFilterTree: res.data, isLoading: false, isFetched: true });
        return res.data;
      } else {
        set({ error: 'Failed to fetch category filter tree', isLoading: false, isFetched: true });
        return [];
      }
    } catch (error) {
      console.error('Failed to fetch category filter tree:', error);
      set({ error: error.message, isLoading: false, isFetched: true });
      return [];
    }
  },

  // ============ HELPER FUNCTION ============
  // This function checks: if data exists then return it, if not then fetch
  getCategoryFilterTree: async () => {
    const state = get();
    if (state.categoryFilterTree.length > 0) {
      return state.categoryFilterTree;  // Data exists → return
    }
    return state.fetchCategoryFilterTree();  // No data → fetch
  },

  // ============ RESET FUNCTION ============
  // Clear cache (used when user logs out or needs refresh)
  reset: () => {
    set({ categoryFilterTree: [], isLoading: false, isFetched: false, error: null });
  },
}));

export default useCategoryFilterTree;

